// @flow
import { getToken } from 'utilities/token'

export const isLoggedIn = (): boolean => getToken() !== null
